module.exports = __webpack_public_path__ + "static/media/icon-locker.4e21dd43.svg";